import React from 'react';
import './Social.css';
import AnimatedSection from '../AnimatedSection';
import { FireSimple } from '@phosphor-icons/react';

function Social() {
    return (
        <section className="social" id="social">
            <div className="social-wrapper">
            <AnimatedSection animationType="slide-up">
                <div className="lp-section-header">
                    <h2 className="lp-section-title">
                        Your Social Money <span className="lp-section-title-highlight">Identity</span>
                    </h2>
                    <p className="lp-section-subtitle">
                        You're more than a wallet address. Create a profile, pick a name, customize your look, and belong to a squad.
                    </p>
                </div>
            </AnimatedSection>

            <div className="social-grid">
                <AnimatedSection animationType="slide-up" stagger={1}>
                    <div className="social-card">
                        <div className="social-card-image">
                            <img
                                src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsocial-1.png?alt=media&token=29dda672-dd8b-4076-9fcc-8488dfff7130"
                                alt="Real Names, Not Wallets"
                            />
                        </div>
                        <div className="social-card-content">
                            <h3 className="lp-section-card-label-h3">Real Names, Not Wallets</h3>
                            <p className="lp-section-card-body-p">Send and receive using your name or pseudo, no long wallet strings required.</p>
                        </div>
                    </div>
                </AnimatedSection>

                <AnimatedSection animationType="slide-up" stagger={2}>
                    <div className="social-card">
                        <div className="social-card-image">
                            <img
                                src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsocial-2.png?alt=media&token=b6b90289-62c9-4e65-998e-511898c0e5d0"
                                alt="Drip Your Profile"
                            />
                        </div>
                        <div className="social-card-content">
                            <h3 className="lp-section-card-label-h3">Drip Your Profile</h3>
                            <p className="lp-section-card-body-p">Customize your avatar borders, profile themes, and wallet backgrounds to match your vibe.</p>
                        </div>
                    </div>
                </AnimatedSection>

                <AnimatedSection animationType="slide-up" stagger={3}>
                    <div className="social-card">
                        <div className="social-card-image">
                            <img
                                src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsocial-3.png?alt=media&token=b43d78a9-3a56-482f-9962-be1450bbe542"
                                alt="Your Social Profile"
                            />
                        </div>
                        <div className="social-card-content">
                            <h3 className="lp-section-card-label-h3">Your Social Profile</h3>
                            <p className="lp-section-card-body-p">Your payments, squads, activity, and reputation, all in one on-chain profile.</p>
                        </div>
                    </div>
                </AnimatedSection>

                <AnimatedSection animationType="slide-up" stagger={4}>
                    <div className="social-card">
                        <div className="social-card-image">
                            <img
                                src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsocial-4.png?alt=media&token=0a94d80b-ec37-4557-8382-8a40dc90961a"
                                alt="Find Your Community"
                            />
                        </div>
                        <div className="social-card-content">
                            <h3 className="lp-section-card-label-h3">Find Your Community</h3>
                            <p className="lp-section-card-body-p">Join squads, crew up for trips or events, and build your on-chain community.</p>
                        </div>
                    </div>
                </AnimatedSection>
            </div>

            <AnimatedSection animationType="fade-in" stagger={5}>
                <div className="social-cta">
                    <a 
                        href="#download" 
                        onClick={(e) => {
                            e.preventDefault();
                            const element = document.getElementById('download');
                            if (element) {
                                element.scrollIntoView({ behavior: 'smooth' });
                            }
                        }}
                        className="social-cta-button"
                    >
                        <FireSimple weight="fill" size={20} />Start Splitting
                    </a>
                </div>
            </AnimatedSection>
            </div>
        </section>
    );
}

export default Social;

